module.exports = __webpack_public_path__ + "static/img/0008-A-01.ee06e67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audioimg/0008-A-01.jpg
// module id = Xxex
// module chunks = 0